module.exports = __webpack_public_path__ + "static/media/dschungel_active.de4e14e1.png";